export const CUSTOMER_STOCK_VIN_COLUMN = 'Full VIN Code';

export const CUSTOMER_STOCK_SOURCE_FIELDS = [
  {
    csv: 'Locn Descr',
    title: 'BMW Location',
    titleKey: 'stockReconciliationBmwLocation',
    sortField: 'locnDescr',
    aliases: ['Locn Descr', 'BMW Location', 'Location'],
    width: 150,
  },
  {
    csv: 'Model Descr',
    title: 'BMW Model',
    titleKey: 'stockReconciliationBmwModel',
    sortField: 'modelDescr',
    aliases: ['Model Descr', 'BMW Model', 'Model'],
    width: 250,
  },
] as const;

export const CUSTOMER_STOCK_UPLOAD_FIELDS = [
  CUSTOMER_STOCK_VIN_COLUMN,
  ...CUSTOMER_STOCK_SOURCE_FIELDS.map((field) => field.csv),
] as const;

export const normalizeStockHeader = (value: string) =>
  value.trim().replace(/\s+/g, ' ').toLowerCase();

export const findStockHeader = (headers: string[], expected: string) =>
  headers.find(
    (header) => normalizeStockHeader(header) === normalizeStockHeader(expected),
  );

export const sourceFieldValue = (
  source: Record<string, string> | undefined,
  field: (typeof CUSTOMER_STOCK_SOURCE_FIELDS)[number],
) => {
  if (!source) return undefined;
  for (const alias of field.aliases) {
    const key = Object.keys(source).find(
      (name) => normalizeStockHeader(name) === normalizeStockHeader(alias),
    );
    const value = key ? source[key]?.trim() : undefined;
    if (value) return value;
  }
  return undefined;
};
